import { UserValidateResponse } from "../types/users";
import { API_URL } from "../config";
import { axiosApi } from "../axios";
import axios from "axios";

export const validateUser = async (userId: string): Promise<UserValidateResponse> => {
  try {
    const response = await axiosApi.get<UserValidateResponse>(`${API_URL}/users/${userId}`);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (error.response?.status === 401) {
        throw new Error("You are not authorized to use the add-in please contact FileOps to purchase a licence.");
      } else {
        // Handle other Axios-specific errors
        throw new Error(`Failed to validate user: ${error.response?.status} ${error.response?.statusText}`);
      }
    } else {
      // Handle other errors
      throw new Error("An unexpected error occurred while validating the user.");
    }
  }
};
